module.exports = {"attributes":{"width":"7","height":"12","viewBox":"0 0 7 12","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M.7824 6.2805c0-.2084.0798-.4168.2385-.5756L5.9056.82 7.057 1.9712 2.7477 6.2805l4.3093 4.3093-1.1512 1.1512-4.885-4.885c-.1586-.1587-.2384-.367-.2384-.5755\" />"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/arrow-left.svg
// module id = 1255
// module chunks = 0